import { ActivityParameter } from 'runtime/data/activityparameter';

export class ActivityExecutionRequested
{
    static eventName() { return 'ActivityExecutionRequested'; }
    eventName = ActivityExecutionRequested.eventName;

    activityName: string;
    parameters: ActivityParameter[];
    onExecutionCompleted: Function;
    context: string;
    retainResults: string[];

    constructor(activityName: string, context: string, parameters: ActivityParameter[], onExecutionCompleted: Function, retainResults?: string[]) {
        this.activityName = activityName;
        this.parameters = parameters || [];
        this.onExecutionCompleted = onExecutionCompleted || (() => { });
        this.context = context;
        this.retainResults = retainResults || [];
    }
}